import { render, staticRenderFns } from "./detailtui.vue?vue&type=template&id=97f1bcd4&scoped=true&"
import script from "./detailtui.vue?vue&type=script&lang=js&"
export * from "./detailtui.vue?vue&type=script&lang=js&"
import style0 from "./detailtui.vue?vue&type=style&index=0&id=97f1bcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1bcd4",
  null
  
)

export default component.exports